// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7a893926","455":"1634fc7a"}[chunkId] + ".chunk.js";
};